export function CoreQuantityDirective () {
  function round(num) {
    return Math.round(num * 100) / 100;
  }

  return {
    require : 'ngModel',
    restrict: 'A',
    link (scope, element, attr, ctrl) {
      ctrl.$parsers.push(value => {
        const max = parseFloat(attr.max);
        const min = parseFloat(attr.min);

        if (angular.isDefined(min) && value && parseFloat(value) < min) {
          return null;
        }

        if (angular.isDefined(max) && value && parseFloat(value) > max) {
          return null;
        }

        return value ? round(value) : 0;
      });

      ctrl.$formatters.push(value => {
        const max = parseFloat(attr.max);
        const min = parseFloat(attr.min);


        if (min && value && parseFloat(value) < min) {
          ctrl.$modelValue = null;

          return null;
        }

        if (max && value && parseFloat(value) > max) {
          ctrl.$modelValue = null;

          return null;
        }

        return value ? round(value) : 0;
      });
    }
  };
}